import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxAmountValidator(getMax: () => number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const max = getMax();
    const value = control.value;
    if (value !== null && value > max) {
      return { maxAmount: { max, actual: value } };
    }
    return null;
  };
}
